import {IPrice} from "../services/order-service";

export function formatPrice(price: IPrice) {
	let formattedPrice = '';

	const replaceDecimalSeparatorInPrice = (amount: number, decimalSeparator: string) => {
		return amount.toFixed(2).replace('.', decimalSeparator);
	};

	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true") {
		formattedPrice += replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator);
	} else {
		if (price.Currency.DisplayLeftToPrice)
			formattedPrice += price.Currency.CurrencySymbol + ' ' + replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator);
		else
			formattedPrice += replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator) + ' ' + price.Currency.CurrencySymbol;
	}

	return formattedPrice;
}

export function formatItemTotal(itemTotal: string, currencySymbol: string) {
	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true" && itemTotal.includes(currencySymbol)) {
		return itemTotal.replace(currencySymbol, '').replace('  ', ' ');
	}
	return itemTotal;
}

export function formatCalculationDescription(calculatedPriceDescription: string, currencySymbol: string) {
	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true" && calculatedPriceDescription.includes(currencySymbol)) {
		return calculatedPriceDescription.replace(currencySymbol, '').replace('  ', ' ');
	}
	return calculatedPriceDescription;
}

